import { ButtonPropsColorOverrides } from '@gemini/fe-ds-core';
import { OverridableStringUnion } from '@mui/types';

//FHIR defined code and descriptions http://hl7.org/fhir/ValueSet/appointmentstatus
export function getAppointmentStatusColor(
  status: string,
): OverridableStringUnion<
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning',
  ButtonPropsColorOverrides
> {
  switch (status) {
    case 'Fulfilled':
      return 'success';
    case 'Checked In':
    case 'Arrived':
      return 'warning';
    case 'Cancelled':
    case 'Waitlisted':
    case 'No Show':
    case 'Entered in error':
      return 'error';
    case 'Proposed':
    case 'Pending':
    case 'Booked':
    default:
      return 'info';
  }
}

export function getExamImportStatusColor(
  status: string,
): OverridableStringUnion<
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning',
  ButtonPropsColorOverrides
> {
  switch (status) {
    case 'archived':
      return 'success';
    case 'new':
    default:
      return 'info';
  }
}